import { withStyles } from "@material-ui/core/styles";
import React, { Component } from "react";
import { fontControlStyles } from "../../themeEditor_style";
import FontList from "./FontList";
import FontSettings from "./FontSettings";

class FontControl extends Component {
    render() {
        const { label, classes } = this.props;

        return (
            <div className={classes.labelRoot}>
                <label className={classes.gray}>{label}</label>
                <FontSettings {...this.props} />
                <FontList {...this.props} />
            </div>
        );
    }
}

export default withStyles(fontControlStyles)(FontControl);
